<div *ngIf="creel">
  <div class="colored-yarn-sets-header">
    <h3 class="font-weight-semibold">
      {{ 'TEXTILE_DATA.COLORED_YARN_SET.COLORED_YARN_SET' | bmsTranslate: {count: 2} }}
    </h3>
    <div>
      <mat-label>{{ 'MACHINE.DETAILS.THEORETICAL' | bmsTranslate }}</mat-label>
      <mat-slide-toggle [checked]="isPreviewMapToggled()" (change)="togglePreviewMap($event.checked)"></mat-slide-toggle>
      <mat-label>{{ 'MACHINE.DETAILS.ACTIVE' | bmsTranslate }}</mat-label>
    </div>
    <div>
      <mat-label>{{ 'TEXTILE_DATA.COLOR.COLOR' | bmsTranslate: {count: 2} }}</mat-label>
      <mat-slide-toggle [checked]="isPreviewTypeToggled()" (change)="togglePreviewType($event.checked)"></mat-slide-toggle>
      <mat-label>{{ 'TEXTILE_DATA.YARN_TYPE.YARN_TYPE' | bmsTranslate: {count: 2} }}</mat-label>
    </div>
  </div>
  <div>
    <app-creel-preview-table
      [coloredYarnSetsWithStartDent]="creel.coloredYarnSetsWithStartDent"
      [creelMap]="creel.mappingForCurrentPositionOnMachine"
      [previewMap]="creelPreviewMap"
      [previewType]="creelPreviewType"
    >
    </app-creel-preview-table>
  </div>
  <div class="button-skeleton-wrapper standard-btn mt-24" *ngIf="canEditCreelMapping">
    <button mat-stroked-button (click)="editCreelMapping.emit()">
      {{ 'MACHINE.DETAILS.EDIT_MAPPING' | bmsTranslate }}
    </button>
  </div>
</div>
